/**
 * Project panel
 *
 * Created by stefensuhat on 08/08/18 2.52 PM
 */

import { api } from 'utils/index';

const defaultState = { items: [], errors: null };

const model = {
    name: 'supplier',
    state: defaultState,
    reducers: {
        reset: state => ({ ...state, ...defaultState }),
        fetchResponse: (state, payload) => ({ ...state, items: payload.data }),
    },
    effects: {
        async fetch(params) {
            await api.get('suppliers', params)
                .then(response => this.fetchResponse(response));
        },
    },
    selectors: (slice, createSelector) => ({
        all() {
            return createSelector(slice, state => state.supplier, supplier => supplier.items);
        },
    }),
};

export default model;
